<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[headerIcon]="{fontIcon: 'fa-trash-alt', fontSet: 'fad'}"
	[headerText]="T.SCHEDULER_EVENT_DIALOG_HEADER_EVENT_LOGS | translate"
	[matDialogData]="data"
	[rect]="rect"
>
	<ng-container dialogContent>
		<div class="scrollableTable">
			<table [dataSource]="schedulerEventLogEntries" mat-table>
				<ng-container matColumnDef="createOn">
					<th *matHeaderCellDef mat-header-cell>
						{{ T.SCHEDULER_EVENT_DIALOG_CREATED_DATE | translate }}
					</th>
					<td *appMatCellDef="let element; dataSource: schedulerEventLogEntries" class="fixWidth" mat-cell>
						{{ element.createdOn | date: (T.DATE_FORMAT_ADMIN | translate): '': translate.currentLang }}
						<button
							(click)="_simUtilityServiceInjection.copyToClipBoard(element.text)"
							[matTooltip]="T.SHARED_COPY_VALUE_TOOLTIP | translate"
							appStopPropagation
							class="copyIcon"
							color="accent"
							mat-icon-button
							matTooltipClass="accent"
						>
							<mat-icon fontIcon="fa-clipboard" fontSet="fad" />
						</button>
					</td>
				</ng-container>

				<ng-container matColumnDef="type">
					<th *matHeaderCellDef mat-header-cell>
						{{ T.SCHEDULER_EVENT_DIALOG_TYPE | translate }}
					</th>
					<td *appMatCellDef="let element; dataSource: schedulerEventLogEntries" class="fixWidth" mat-cell>
						{{ SchedulerEventLogType[element.type] }}
					</td>
				</ng-container>

				<ng-container matColumnDef="name">
					<th *matHeaderCellDef mat-header-cell>
						{{ T.SCHEDULER_EVENT_DIALOG_NAME | translate }}
					</th>
					<td *appMatCellDef="let element; dataSource: schedulerEventLogEntries" class="fixWidth" mat-cell>
						{{ element.name }}
					</td>
				</ng-container>

				<ng-container matColumnDef="text">
					<th *matHeaderCellDef mat-header-cell>
						{{ T.SCHEDULER_EVENT_DIALOG_Text | translate }}
					</th>
					<td *appMatCellDef="let element; dataSource: schedulerEventLogEntries" mat-cell>
						<p
							[innerHTML]="element.text"
							[ngClass]="{
								newline: true,
								scrollable: element.text.length > 100,
							}"
						></p>
					</td>
				</ng-container>

				<tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
				<tr
					*matRowDef="let row; columns: displayedColumns"
					[ngClass]="{
						danger: row.type === SchedulerEventLogType.Failure,
						success: row.type === SchedulerEventLogType.Success,
					}"
					mat-row
				></tr>
			</table>
		</div>
		<mat-paginator
			#paginator
			(page)="pageChangeEvent($event)"
			[length]="totalRecords"
			[pageIndex]="pageIndex"
			[pageSizeOptions]="[5, 10, 20, 30]"
			[pageSize]="pageSize"
			showFirstLastButtons
		/>
	</ng-container>
	<ng-container actions>
		<sim-button
			(onClick)="clean()"
			[color]="'warn'"
			[icon]="{fontSet: 'fad', fontIcon: 'fa-trash-alt'}"
			[label]="T.SCHEDULER_EVENT_DIALOG_CLEAN_LOGS | translate"
		/>
		<sim-button
			(onClick)="refresh()"
			[color]="'accent'"
			[icon]="{fontSet: 'fad', fontIcon: 'fa-sync-alt'}"
			[label]="T.BUTTON_REFRESH | translate"
		/>
		<sim-button (onClick)="close()" [color]="'accent'" [icon]="{fontSet: 'fad', fontIcon: 'fa-check'}" [label]="T.BUTTON_OK" />
	</ng-container>
</sim-basic-material-dialog>
